add_route_handler = {

    properties: {
        title: 'Tell Us Why',
        checkInBounds: true,
        wordLimit: 500
    },

    onLoad: function(){
        var self = this;
        //Zoom to selected area
        if (self.grabDraw() !== false){
            self.centerDraw(mapData.drawnItemsLayer.getLayers()[0]);
        }

        map.closePopup();
    },

    centerDraw: function(layer){
        var self = this;
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();

        var getHeaderWidth = function() {
            var totalWidth = 0;
            $(".content-root").each(function() {
                if ($(this).hasClass("hidden")) {} else {
                    totalWidth = $(this).outerWidth(true);
                }
            });
            return totalWidth;
        };

        var getHeaderHeight = function() {
            var totalHeight = 0;
            $(".content-root").each(function() {
                if ($(this).hasClass("hidden")) {} else {
                    totalHeight = $(this).outerHeight(true);
                }
            });
            return totalHeight;
        };

        if (layer instanceof L.Polyline) {

            map.fitBounds(layer.getBounds());
            // self.snapToRoad(layer);

        }


    },

    grabDraw: function(){
        var layer = mapData.drawnItemsLayer.getLayers()[0];

        if (layer){
            var shape = layer.toGeoJSON();
            var shape_for_db = JSON.stringify(shape);
            return shape_for_db;
        }
        else {
            return false;
        }
    },

    wordCount: function( val ){
        var wom = val.match(/\S+/g);
        return val.length || 0;
        // return wom ? wom.length : 0;
    },

    formatText: function(comment) {
        comment = comment.replace(/(<([^>]+)>)/gi, "");
        if ($.trim(comment).length > 0) {
            return comment;
        }
        return "";
    },

    formSubmit: function(event) {
        $('#submit').prop('disabled', true);

        var self = this;

        var underLimit = self.wordCount($('textarea[name=comment]').val()) <= 500;

        if (underLimit){

            var fd = new FormData();
            var photo =  $('input[name=photo]').prop('files')[0];

            var layer = mapData.drawnItemsLayer.getLayers()[0];
            var shape = layer.toGeoJSON();

            if (photo){
                fd.append( 'file',  photo );
            };


            var formData = {
                'name': self.formatText($('input[name=name]').val()) || 'Anonymous',
                'comment': self.formatText($('textarea[name=comment]').val()),
                'category': $("select[name=category]").val(),
                created: 'date',
                type: shape.geometry.type,
                geometry: JSON.stringify(shape.geometry.coordinates)
            };

            $.each(formData, function(key, value)
            {
                fd.append(key, value);
            });

            $.ajax({
                type: "POST",
                url: mapData.suggestionsURL,
                processData: false,
                contentType: false,
                crossDomain: false,
                data: fd,
                success: function(json) {
                    $('#submit').prop('disabled', false);
                    if (json.error) {
                        if (json.error.code == 'imageFail'){
                            alert('Photo must be under 5 MB and be a gif, jpg, or png.')
                        }
                        else {
                            alert('Unable to complete your request at this time.');
                        }

                    } else {
                        mapData.drawnItemsLayer.clearLayers();
                        window.location.href = "#/step-three/";
                    }
                },
                error: function(xhr, textStatus, errorThrown) {
                    $('#submit').prop('disabled', false);
                    alert('error');

                }
            });
        }
        else {
            $('#submit').prop('disabled', false);
        }


        event.preventDefault();
    },

    events: function() {
        var self = this;
        self.onLoad();

        $("#suggestion-submit").submit(function(event) {
            self.formSubmit(event);
        });

        $('.content-error').click(function(event) {
            $(this).removeClass('animated bounceIn shake').addClass('hidden');
        });

        $('.content-close-btn').click(function(event) {
            mapData.drawnItemsLayer.clearLayers();
        });

        //On File Upload Set
        $('input[name=photo]').change(function(e){
            $in=$(this);

            if ($in.prop('files').length > 0){
                $in.next().html($in.prop('files')[0].name);
            }
            else {
                $in.next().html('Choose File...');
            }
        });

        $('textarea[name=comment]').on('input click', function() {
            var wordCount = self.wordCount($(this).val());
            if (wordCount > self.properties.wordLimit){
                $('.story-word').text(self.properties.wordLimit);
                $(this).addClass('required');
                $('.story-min').addClass('required');
            }
            else {
                $(this).removeClass('required');
                $('.story-min').removeClass('required');
                $('.story-word').text(wordCount);
            }
        });
    }
}